var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvScraper({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.925781,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.925781,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#ECECF1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2101_22316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8775 32.6328H19.1068C18.7392 32.6328 18.4388 32.9045 18.4388 33.2451C18.4388 33.5821 18.7353 33.8574 19.1068 33.8574H30.8815C31.2491 33.8574 31.5494 33.5857 31.5494 33.2451C31.5455 32.9045 31.2491 32.6328 30.8775 32.6328Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8775 29.9512H19.1068C18.7392 29.9512 18.4388 30.2229 18.4388 30.5635C18.4388 30.9004 18.7353 31.1758 19.1068 31.1758H30.8815C31.2491 31.1758 31.5494 30.904 31.5494 30.5635C31.5455 30.2229 31.2491 29.9512 30.8775 29.9512Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9921 16.9941C23.4111 16.9941 22.1186 18.1753 22.1186 19.6282C22.1186 21.0775 23.4111 22.2586 24.9921 22.2586C26.5732 22.2586 27.8656 21.0774 27.8656 19.6246C27.8656 18.1717 26.5732 16.9941 24.9921 16.9941ZM24.9921 21.0304C24.1502 21.0304 23.4585 20.3964 23.4585 19.6246C23.4585 18.8529 24.1462 18.2188 24.9921 18.2188C25.838 18.2188 26.5257 18.8529 26.5257 19.6246C26.5257 20.3963 25.834 21.0304 24.9921 21.0304Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8063 23.5819C26.3676 22.7123 23.6244 22.7123 21.1858 23.5819C20.3873 23.8681 19.8537 24.5963 19.8537 25.3971V27.8826C19.8498 28.2195 20.1502 28.4949 20.5178 28.4949H29.4704C29.8379 28.4949 30.1383 28.2232 30.1383 27.8826V25.3971C30.1383 24.5963 29.6047 23.8681 28.8063 23.5819ZM28.8063 27.2738H21.1858V25.4007C21.1858 25.1036 21.3795 24.8282 21.668 24.7268C23.7984 23.9695 26.1937 23.9695 28.3241 24.7268C28.6127 24.8319 28.8064 25.1 28.8064 25.4007V27.2738H28.8063Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1423 14.4258H21.0395C20.5257 14.4258 20.0435 14.6069 19.6799 14.9403L16.4861 17.8678C16.1225 18.2012 15.9249 18.6431 15.9249 19.1142V34.6576C15.9249 35.6323 16.7905 36.4257 17.8537 36.4257H32.1462C33.2095 36.4257 34.075 35.6322 34.075 34.6576V16.1939C34.0632 15.2193 33.1976 14.4258 32.1423 14.4258ZM19.8498 16.5127V18.0272H18.1976L19.8498 16.5127ZM32.7312 20.9729H30.249C29.8814 20.9729 29.581 21.2446 29.581 21.5852C29.581 21.9221 29.8774 22.1975 30.249 22.1975H32.7312V23.2845H31.8221C31.4545 23.2845 31.1541 23.5562 31.1541 23.8968C31.1541 24.2337 31.4506 24.5091 31.8221 24.5091H32.7312V34.6612C32.7312 34.962 32.4664 35.2047 32.1423 35.2047H17.8419C17.5178 35.2047 17.253 34.962 17.253 34.6649V19.2482H20.5178C20.8854 19.2482 21.1858 18.9765 21.1858 18.6359V15.6432H32.1423C32.4664 15.6432 32.7312 15.8859 32.7312 16.183V20.9729Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2101_22316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22,
    fill: "white",
    transform: "translate(13 14.4258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvScraper);
export default __webpack_public_path__ + "static/media/CVScraper.dbc211ae34f39b67533457e151bd11f2.svg";
export { ForwardRef as ReactComponent };